export default __webpack_public_path__ + "static/research-automation-c40262e6c3a8e8daa8c3f94115c126c3.mp4";